import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  currentLegalVersion,
  lazyLegalModules,
  loadCurrentLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/terms/*.md"))

export const Route = createFileRoute("/_content/terms/")({
  head: () =>
    seoMeta({
      title: "Terms of Service",
      description: "Terms and conditions for using the Entire platform.",
      url: "https://entire.com/terms",
      image: "https://entire.com/og/page/terms.png",
    }),
  loader: () => loadCurrentLegalVersion(modules),
  component: TermsPage,
})

function TermsPage() {
  const { asOf } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const current = currentLegalVersion(versions)!
  return <LegalVersionPage basePath="/terms" version={current} versions={versions} />
}
